/**
 * Clientes abertos por último (só neste navegador): atalho no menu lateral
 * para voltar ao dossiê. Falha de armazenamento (aba anônima, cota) não
 * atrapalha nada: a lista só fica vazia.
 */
import { useEffect, useState } from 'react'

export interface RecentClient {
  id: string
  name: string
}

const KEY = 'lawtech:clientes-recentes'
const EVENT = 'lawtech:clientes-recentes'
export const MAX_RECENT_CLIENTS = 5

export function readRecentClients(): RecentClient[] {
  try {
    const parsed = JSON.parse(localStorage.getItem(KEY) ?? '[]')
    return Array.isArray(parsed)
      ? parsed.filter((c): c is RecentClient => typeof c?.id === 'string' && typeof c?.name === 'string').slice(0, MAX_RECENT_CLIENTS)
      : []
  } catch {
    return []
  }
}

/** Põe o cliente no topo (sem repetir) e avisa o menu. */
export function rememberClient(client: RecentClient): void {
  const next = [client, ...readRecentClients().filter((c) => c.id !== client.id)].slice(0, MAX_RECENT_CLIENTS)
  try {
    localStorage.setItem(KEY, JSON.stringify(next))
  } catch {
    return
  }
  window.dispatchEvent(new Event(EVENT))
}

export function useRecentClients(): RecentClient[] {
  const [clients, setClients] = useState(readRecentClients)
  useEffect(() => {
    const refresh = () => setClients(readRecentClients())
    window.addEventListener(EVENT, refresh)
    window.addEventListener('storage', refresh)
    return () => {
      window.removeEventListener(EVENT, refresh)
      window.removeEventListener('storage', refresh)
    }
  }, [])
  return clients
}
